/**
 * Pin the footer to the bottom of the page.
 */
(function() {
    $(window).on('resize', function() {

        var scope = $('body'),
            header = scope.children('header'),
            body = scope.children('.body'),
            footer = scope.children('footer'),
            windowHeight = $(window).height(),
            headerHeight = header.outerHeight(true),
            footerHeight = footer.outerHeight(true),
            bodyMargin = body.outerHeight(true) - body.innerHeight(),
            newBodyHeight = windowHeight - (headerHeight + footerHeight + bodyMargin),
            originalBodyHeight = body.data('original-height');

        if(typeof tabularData !== 'undefined' && tabularData == true)
        {
            var $iframe = scope.find("iframe");
            if($iframe.length > 0)
            {
                var contentHeight = $('body', $iframe.contents()).height();
                $("#documentViewContent").css('height', contentHeight);
                bodyMargin = body.innerHeight() - body.outerHeight(true);
                newBodyHeight = windowHeight - (headerHeight + footerHeight + bodyMargin);
            }
        }

        if (typeof body.data('original-height') !== 'number') {
            originalBodyHeight = body.outerHeight();
            body.data('original-height', originalBodyHeight);
        }

        body.css('min-height', newBodyHeight > originalBodyHeight ? newBodyHeight : '');
    }).trigger('resize');
})();
